



























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { getStorage } from '@/utils/storage';
import { hasAuth } from '@/utils/validate';
import { widgetItems, parseConfig, genConfig } from '../render';
import { IWidgetDto } from '../types';
import { IActions, IWidgets } from '@/store/home/stats/types';
import Modal from '@/components/dialog/Modal.vue';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';

interface ITem extends IWidgetDto {
  newCols: number;    // 新输入的列数
}

const Stats = namespace('home/stats');

// 首页组件删除或布局设置弹窗
@Component({
  components: { Modal, TooltipIcon },
})
export default class HomeWidgetSettings extends Vue {
  @Stats.Action('queryWidgetList') public queryWidgetList!: IActions['queryWidgetList'];
  @Stats.State('widgetList') public widgetList!: IWidgets;

  @Stats.Action('saveWidgetConfig') public saveWidgetConfig!: IActions['saveWidgetConfig'];
  @Stats.State('saving') public saving!: boolean;

  @Prop({ type: Boolean, default: false }) public disabled!: boolean;

  public userInfo = JSON.parse(getStorage('userInfo') || '{}');

  public visible = false;
  public editable = false;

  public dragOld = -1; // 拖拽源对象索引
  public dragNew = -1; // 拖拽目标对象索引

  public savedItems: ITem[] = [];   // 已保存列表
  public unSavedItems: ITem[] = []; // 未保存列表

  // 全部组件列表
  public get allList() {
    const userId = this.userInfo.id;
    return widgetItems.filter((item) => hasAuth(item.auth)).map((item, i) => {
      const { auth, ...rest } = item;
      const config = genConfig(null);
      return { ...rest, userId, config, configId: null, newCols: 6 };
    });
  }

  // 初始的已保存列表
  public get initSavedList() {
    if (!this.visible || this.widgetList.loading) {
      return [];
    }
    return this.widgetList.data.map((item) => {
      const { userId, configId, widgetCode, config: widgetConfig } = item;
      const config = parseConfig(widgetConfig);
      const data = widgetItems.find((widget) => widget.code === widgetCode);
      const { auth, ...rest } = data || {};
      return { ...rest, userId, config, configId, newCols: config.cols };
    }).sort((a, b) => {
      // 从小到大排序，-1排最后面
      const aSort = a.config.sortNo;
      const bSort = b.config.sortNo;
      if (aSort === -1) { return 1; }
      if (bSort === -1) { return -1; }
      return aSort - bSort;
    });
  }

  // 初始化列表数据
  @Watch('initSavedList', { immediate: true })
  public watchInitSavedList(list: ITem[]) {
    const savedCodes = list.map((item) => item.code);
    this.savedItems = [...list];
    this.unSavedItems = this.allList.filter((item) => !savedCodes.includes(item.code));
  }

  // 从未保存列表里添加
  public onAdd(record: ITem) {
    const code = record.code;
    this.unSavedItems = this.unSavedItems.filter((item) => item.code !== code);
    this.savedItems = [...this.savedItems, { ...record }];
  }

  // 从已保存列表里删除
  public onDelete(record: ITem) {
    // 删除时，列宽重置为6, 排序编号重置为-1
    const config = { ...record.config, cols: 6, sortNo: -1 };
    this.unSavedItems = [...this.unSavedItems, { ...record, config, newCols: 6 }];
    this.savedItems = this.savedItems.filter((item) => item.code !== record.code);
  }

  // 失去焦点或按回车健时，保存布局列宽
  public onEdit(record: ITem, index: number) {
    const newCols = parseInt(`${record.newCols}`, 10) || 6;
    const cols = Math.max(1, Math.min(12, newCols));
    const config = { ...record.config, cols };
    this.$set(this.savedItems, index, { ...record, config, newCols: cols });
  }

  // 设置拖拽样式
  public dragClass(record: ITem) {
    const code = record.code;
    const oldCode = this.savedItems[this.dragOld]?.code;
    const newCode = this.savedItems[this.dragNew]?.code;
    const isStart = code === oldCode;
    const isEnter = code === newCode && code !== oldCode;
    return { 'home-drag-box-start': isStart, 'home-drag-box-enter': isEnter };
  }

  // 拖拽结束
  public onDragEnd() {
    if (this.dragOld !== -1 && this.dragNew !== -1 && this.dragOld !== this.dragNew) {
      const oldData = this.savedItems[this.dragOld];
      const newData = this.savedItems[this.dragNew];
      const newItems = [...this.savedItems];
      newItems[this.dragOld] = { ...newData };
      newItems[this.dragNew] = { ...oldData };
      this.savedItems = newItems;
    }
    this.dragOld = -1;
    this.dragNew = -1;
  }

  // 保存设置
  public async onSubmit() {
    const userId = this.userInfo.id;
    const delIds = this.unSavedItems
      .filter((item) => !!item.configId)
      .map((item) => item.configId) as number[];
    const configs = this.savedItems.map((item, i) => {
      const { configId, code: widgetCode, config: widgetconfig } = item;
      const config = JSON.stringify({ ...widgetconfig, sortNo: i + 1 });
      return configId ? { widgetCode, config, configId } : { widgetCode, config };
    });
    await this.saveWidgetConfig({ userId, delIds, configs });
    this.queryWidgetList();
    this.visible = false;
  }

  // 打开弹窗时，查询已保存列表
  @Watch('visible')
  public watchVisible(visible: boolean) {
    if (visible) {
      this.editable = false;
      this.queryWidgetList();
    }
  }
}
